module.exports = __webpack_public_path__ + "img/message.e5557404.png";